// extracted by mini-css-extract-plugin
export default {"head_line":"About_head_line__-OYwX","untouch":"About_untouch__TlX05"};